import { Questionnaire } from "./Questionnaire";
import { Registration } from "./Registration";
import { User } from "./User";
import { Event } from "./Event";
import { Language, LanguageSchema } from "./Language";
import tv from "typed-object-validator";
import { Region } from "./Region";

export type TestStatus = "open" | "closed" | "hidden" | "archived";
export const TestStatusValues = ["open", "closed", "hidden", "archived"];
export const TestStatusSchema = tv.value("open").or(tv.value("closed")).or(tv.value("hidden")).or(tv.value("archived"));

export const PartialRegionToTestSchema = tv.object({
    testId: tv.number(),
    regionName: tv.string(),
});
export interface RegionToTest {
    test?: Test;
    testId: number;
    region?: Region;
    regionName: string;
}

export const PartialTestSchema = tv.object({
    id: tv.number().optional(),
    name: tv.string().min(1, "Geef je onderzoek een naam.").max(100, "Deze naam is te lang. Gebruik de beschrijving voor een langere tekst."),
    duration: tv
        .number()
        .float(false, "Moet een geheel getal zijn.")
        .min(0, "Duurtijd is minimum 0.")
        .max(1440, " Een sessie kan maximum 24 uur duren."),
    redirect: tv.string().optional().nullable(),
    reward: tv.number().float(false, "Moet een geheel getal zijn.").min(0, "Beloning is minimum 0 euro.").max(100, " Beloning is maximum 1000 euro."),
    status: TestStatusSchema,
    description: tv.string().max(2000, "Dit is te lang! Max 2000 karakters."),
    minAge: tv.number().float(false, "Moet geheel getal zijn.").min(0, "Te laag.").max(100, "Te hoog."),
    maxAge: tv.number().float(false, "Moet geheel getal zijn.").min(0, "Te laag.").max(100, "Te hoog."),
    thumbnail: tv.string().nullable().optional(),
    language: LanguageSchema,
    inRegions: tv.array(PartialRegionToTestSchema),
});

export class Test {
    id?: number;
    /**
     * @v-min 1 Geef je onderzoek een naam.
     * @v-max 100 Deze naam is te lang. Gebruik de beschrijving voor een langere tekst.
     */
    name: string;
    /**
     * @v-min 0 Duurtijd is minimum 0.
     * @v-max 1440 Een sessie kan maximum 24 uur duren.
     * @v-int true Moet een geheel getal zijn.
     */
    duration: number;
    /**
     * @v-min 0 Beloning is minimum 0 euro.
     * @v-max 1000 Beloning is maximum 1000 euro.
     * @v-int true Moet een geheel getal zijn.
     */
    reward: number;
    status: TestStatus;
    /**
     * @v-max 2000 Dit is te lang! Maximaal 2000 karakters.
     */
    description: string;
    /**
     * @v-min 0 Te laag, 0 is minimum.
     * @v-max 100 Te hoog, 100 is maximum.
     * @v-int true Moet een geheel getal zijn.
     */
    minAge: number;
    /**
     * @v-min 0 Te laag, 0 is minimum.
     * @v-max 100 Te hoog, 100 is maximum.
     * @v-int true Moet een geheel getal zijn.
     */
    maxAge: number;
    language: Language;
    createdTimeStamp: number;
    notifiedUsers: boolean;
    redirect?: string;
    thumbnail?: string;

    inRegions: RegionToTest[];
    authorId?: number;
    author?: User;
    events?: Event[];
    questionnaires?: Questionnaire[];
    registrations?: Registration[];
    modifiedTimeStamp?: number;

    constructor(name: string, language: Language) {
        this.name = name;
        this.duration = 30;
        this.reward = 15;
        this.description = "";
        this.status = "closed";
        this.minAge = 12;
        this.maxAge = 75;
        this.language = language;
        this.createdTimeStamp = new Date().getTime();
        this.notifiedUsers = false;
        this.inRegions = [];
    }
}
